export default {
  computed: {
    activeUser () {
      return this.$store.getters.userInfo || this.$store.getters.activeUser
    },
    currentDomain () {
      return this.$store.getters.currentDomain
    }
  },
  methods: {
    headerGmail () {
      const { email = 'k.syndikat@gmail.com' } = this.activeUser
      const { id = 4 } = this.currentDomain || {}
      return {
        email,
        domain: id
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/headerGmail.js